import userRoutes from './user.routes';

import userListComponent from './components/user.list.component';
import userSaveComponent from './components/user.save.component';
import userFormComponent from './components/user.form.component';
import roleSelectComponent from './components/role.select.component';
import setPasswordEmailComponent from './components/email.setPassword.component';

import usersService from './services/users.service';
import rolesService from './services/roles.service';

import userSaveController from './controllers/user.save.controller';
import userFormController from './controllers/user.form.controller';
import userListController from './controllers/user.list.controller';
import roleSelectController from './controllers/role.select.controller';
import setPasswordEmailController from './controllers/email.setPassword.controller';

let userModule = angular.module('spabooker.user', [])
    .config(userRoutes)

    .controller('userSaveController', userSaveController)
    .controller('userFormController', userFormController)
    .controller('userListController', userListController)
    .controller('roleSelectController', roleSelectController)
    .controller('setPasswordEmailController', setPasswordEmailController)

    .component('userList', userListComponent)
    .component('userSave', userSaveComponent)
    .component('userForm', userFormComponent)
    .component('roleSelect', roleSelectComponent)
    .component('setPasswordEmail', setPasswordEmailComponent)

    .factory('usersService', usersService)
    .factory('rolesService', rolesService);

export default userModule.name;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/user/index.js